import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Card, CardActionArea, CardActions, CardContent, CircularProgress, Grid, List, ListItem, ListItemText, LinearProgress } from '@material-ui/core';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import { GenerarMatriculaLogic, ObtenerMatriculaLogic, GenerarComprobanteMatriculaLogic, EnvioCorreoLogic } from '../../../view-model/Matricula/Matricula.logic';
// import d1 from '../../../../assets/dist/svg/main.svg';
import { ObtieneProcesoActualLogic } from '../../../view-model/Parametros/Parametros.logic';
import { ObtieneCondicionesLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';

type Props = { onClickContinuar: any, firma: boolean }
export const Finalizado: React.FC<Props> = ({ onClickContinuar, firma }) => {
    const history = useHistory();
    const location = useLocation();
    const [generandoMatricula, setGenerandoMatricula] = useState(true);
    const [matriculaGenerada, setMatriculaGenerada] = useState(false);
    const [codNegocio, setCodNegocio] = useState(0);
    const [rutAlumno, setRutAlumno] = useState(0);
    const [_base64Condiciones, setBase64Condiciones] = useState<string>("");
    const [Matriculado, setMatriculado] = useState(false);

    const [cargandoMatriculado, setCargandoMatriculado] = useState(true);

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });


        } else {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (!firma && _params.codigoNegocio === 3) {
                ObtieneCondicionesLogic(selListaCondiciones, _params.rut);
            } else {
                handleCargaDatosIniciales();
            }
        }
    }, [])

    const selListaCondiciones = (error: Boolean, err: string, Instrucciones: any) => {
        if (error === false && Instrucciones !== undefined) {
            console.log(Instrucciones);
            if (Instrucciones.length > 0) {
                let inst = Instrucciones[0].instrucciones.base64[0].trim();
                setBase64Condiciones(inst);
            }
        }
    }

    useEffect(() => {
        if (_base64Condiciones !== "" && _base64Condiciones !== '') {
            handleCargaDatosIniciales();
        }
    }, [_base64Condiciones])

    const handleCargaDatosIniciales = () => {
        sessionStorage.setItem('fase', JSON.stringify('finalizado'));
        GenerarMatricula();
    }

    const GenerarMatricula = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        /* console.log(_params) */
        setRutAlumno(_params.rut);
        setCodNegocio(_params.codigoNegocio);
        setGenerandoMatricula(false);
        setCargandoMatriculado(true);
        ObtenerMatriculaLogic(selObtenerMatricula, _params.rut, _params.codCarrera, _params.codigoNegocio, _params.codigoPlanificacionAcademica, _params.idPeriodo);
        /* GenerarMatriculaLogic(selGenerarMatricula, _params.idProceso) */
    }
    const selGenerarMatricula = (error: Boolean, err: string, data: any) => {
        // let _tt = JSON.stringify(location.state);
        // let _params = JSON.parse(_tt);

        if (error === false && data !== undefined) {
            /* console.log('Matricula generada: '+data) */
            setTimeout(() => {
                /* setGenerandoMatricula(false) */
                setMatriculaGenerada(data);
                if (data) {
                    ObtieneProcesoActualLogic(selListaProcesoActual);
                    /* GenerarComprobanteMatriculaLogic(selGenerarComprobante, _params.rut, _params.codCarrera,_params.año,_params.periodo,0) */
                }
            }, 3000);


        } else {
            /* console.log(data) */
            setGenerandoMatricula(false);
            setMatriculaGenerada(data.length === 0 ? false : true);
        }
    }
    const selListaProcesoActual = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                let _tt = JSON.stringify(location.state);
                let _params = JSON.parse(_tt);
                /* console.log(data) */
                GenerarComprobanteMatriculaLogic(selGenerarComprobante, _params.rut, _params.codCarrera, data.ano, parseInt(data.periodo), 0, _params.codigoNegocio, _params.codigoPlanificacionAcademica, _params.idPeriodo, _params.idPersona);
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const selObtenerMatricula = (error: Boolean, err: string, data: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        if (error === false && data !== undefined) {
            /* console.log('Matricula generada: '+data) */
            if (!data) {
                setGenerandoMatricula(true);
                setCargandoMatriculado(false);
                GenerarMatriculaLogic(selGenerarMatricula, _params.idProceso, _params.codigoNegocio, _params.idPeriodo, _params.idPersona);
            } else {
                /* GenerarComprobanteMatriculaLogic(selGenerarComprobante, _params.rut, _params.codCarrera,_params.año,_params.periodo,0) */
                setMatriculado(true);
                setCargandoMatriculado(false);
            }

        }
    }
    const selGenerarComprobante = (error: Boolean, err: string, data: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;
        if (error === false && data !== undefined) {
            /* console.log(data.base64) */
            EnvioCorreoLogic(selEnvioCorreo, _params.rut, data.base64, _params.codigoNegocio, _base64Condiciones, idPeriodo, idPersona);
        }
        setGenerandoMatricula(false)
    }
    const selEnvioCorreo = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            console.log("Se envío el correo exitosamente");
        } else {
            console.log("Problemas al enviar el correo");
        }
    }

    return (
        <>
            <main className="site-main enrollment">
                <div className="site-main__container">
                    <p className="enrollment__description"></p>
                    <div className="">
                        <div className="payment-webpay__enrollment">
                            {
                                Matriculado ?
                                    <div style={{ textAlign: 'center', padding: 100 }}>
                                        <CheckCircleOutline style={{ fontSize: 80, color: '#0062a1' }} />
                                        <br />
                                        <br />
                                        {/* <h1><span>Servicio</span></h1> */}
                                        <h3><span>Usted ya se encuentra matriculado en la Universidad del Desarrollo.</span></h3>
                                    </div>
                                    :
                                    ""
                            }
                            {
                                !cargandoMatriculado ?
                                    !Matriculado ?
                                        generandoMatricula ?
                                            <div style={{ textAlign: 'center', padding: 100 }}>
                                                <CircularProgress disableShrink />
                                                <br />
                                                <a><span>Generando Matrícula</span></a>
                                            </div>
                                            :
                                            (
                                                matriculaGenerada ?
                                                    <div style={{ textAlign: 'center', padding: 100 }}>
                                                        <CheckCircleOutline style={{ fontSize: 80, color: '#0062a1' }} />
                                                        <br />
                                                        <br />
                                                        {/* <h1><span>Servicio</span></h1> */}
                                                        {

                                                        }
                                                        {
                                                            codNegocio === 1 ?
                                                                <>
                                                                    <h3><span>Se ha generado la matrícula exitosamente.</span></h3>
                                                                    <h4><span>Enviaremos la boleta correspondiente al correo del responsable financiero.</span></h4>
                                                                </>
                                                                :
                                                                <>
                                                                    <h3><span>Ya eres Alumno de la Universidad del Desarrollo.</span></h3>
                                                                    <h4><span>Has finalizado correctamente tu proceso de matrícula.</span></h4>
                                                                    <h4><span>Enviaremos documentación correspondiente vía mail.</span></h4>
                                                                </>
                                                        }

                                                    </div>
                                                    :
                                                    <div style={{ textAlign: 'center', padding: 100 }}>
                                                        <ErrorOutlineRounded style={{ fontSize: 80, color: 'red' }} />
                                                        <br />
                                                        <br />
                                                        {/* <h1><span>Servicio</span></h1> */}
                                                        <h3><span>Ocurrió un error al generar la matrícula.</span></h3>
                                                        <Button style={{ border: '1px solid gray' }} onClick={() => GenerarMatricula()} color="inherit">Reintentar generar matrícula</Button>
                                                        {/* <a className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={d1+"#chevron-right"}></use></svg> Reintentar generar matricula</a> */}
                                                        {/* <button>Reintentar generar matricula</button> */}
                                                    </div>
                                            ) : "" : ""
                            }
                            {!generandoMatricula || Matriculado ?
                                <div style={{ float: 'right', marginBottom: '-10rem' }}>
                                    <Button
                                        style={{ border: '1px solid gray' }}
                                        onClick={() => {
                                            history.push({
                                                pathname: "/inicio",
                                                state: {
                                                    rut: rutAlumno
                                                }
                                            })
                                        }
                                        }>
                                        Finalizar
                                    </Button>
                                </div> : ""}
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
